export enum ValidationErrorKeys {
	Required = 'required',
	Min = 'min',
	Max = 'max',
	Maxlength = 'maxlength',
	Minlength = 'minlength',
	InvalidCron = 'invalid-cron',
	InvalidCronForm = 'cron-form-invalid',
	UnacceptedValue = 'unaccepted-value',
	MinimalAcceptedRecurrence = 'minimal-accepted-recurrence',
	ForbiddenCharacters = 'ForbiddenCharacters',
	UnrecognizableTimezone = 'Unknown timezone',
	IncompleteTimezone = 'Incomplete timezone',
	UnacceptedCharacters = 'unaccepted-characters',
	LowerUpperBoundViolation = 'lower-upper-bound-violation',
	Duplicates = 'duplicate-values',
	ListItemOrdering = 'list-item-ordering',
	OutOfBounds = 'out-of-bounds',
	Pattern = 'pattern',
	UnavailableToUse = 'unavailable-to-user',
	IncompletePattern = 'incomplete-pattern',
}
